import { useDebugValue, useContext } from 'react';
import { SystemContext } from './SystemContext.js';

function useToken(token, defaultValue) {
  useDebugValue(token);
  var context = useContext(SystemContext);
  return context[token] != null ? context[token] : defaultValue;
}

export { useToken };
